export default "__VITE_ASSET__CdBhfO$e__"